import { TourStep } from "../page-tour.component";

export const COURSE_SESSIONS_TOUR_STEPS: TourStep[] = [
  {
    title: "tour.courseSessions.s1.title",
    description: "tour.courseSessions.s1.desc",
    icon: "ft-book-open",
    accentGradient:
      "linear-gradient(135deg, hsl(221, 83%, 53%) 0%, hsl(250, 55%, 50%) 50%, hsl(280, 60%, 55%) 100%)",
    orbGradient:
      "radial-gradient(circle at 30% 30%, hsl(221, 83%, 68%), hsl(250, 55%, 50%))",
    svgPath:
      "M2 3h6a4 4 0 014 4v14a3 3 0 00-3-3H2zM22 3h-6a4 4 0 00-4 4v14a3 3 0 013-3h7z",
  },
  {
    title: "tour.courseSessions.s2.title",
    description: "tour.courseSessions.s2.desc",
    icon: "ft-pie-chart",
    accentGradient:
      "linear-gradient(135deg, hsl(221, 83%, 53%) 0%, hsl(25, 84%, 52%) 100%)",
    orbGradient:
      "radial-gradient(circle at 30% 30%, hsl(25, 84%, 60%), hsl(221, 83%, 53%))",
    svgPath: "M21.21 15.89A10 10 0 118 2.83M22 12A10 10 0 0012 2v10z",
  },
  {
    title: "tour.courseSessions.s3.title",
    description: "tour.courseSessions.s3.desc",
    icon: "ft-grid",
    accentGradient:
      "linear-gradient(135deg, hsl(221, 83%, 53%) 0%, hsl(190, 75%, 50%) 100%)",
    orbGradient:
      "radial-gradient(circle at 30% 30%, hsl(190, 75%, 60%), hsl(221, 83%, 53%))",
    svgPath: "M3 3h7v7H3zM14 3h7v7h-7zM14 14h7v7h-7zM3 14h7v7H3z",
  },
  {
    title: "tour.courseSessions.s4.title",
    description: "tour.courseSessions.s4.desc",
    icon: "ft-bar-chart-2",
    accentGradient:
      "linear-gradient(135deg, hsl(221, 83%, 53%) 0%, hsl(152, 68%, 38%) 100%)",
    orbGradient:
      "radial-gradient(circle at 30% 30%, hsl(152, 56%, 54%), hsl(221, 83%, 53%))",
    svgPath: "M18 20V10M12 20V4M6 20v-6",
  },
  {
    title: "tour.courseSessions.s5.title",
    description: "tour.courseSessions.s5.desc",
    icon: "ft-chevron-down",
    accentGradient:
      "linear-gradient(135deg, hsl(250, 55%, 50%) 0%, hsl(280, 60%, 55%) 100%)",
    orbGradient:
      "radial-gradient(circle at 30% 30%, hsl(280, 60%, 65%), hsl(250, 55%, 50%))",
    svgPath: "M6 9l6 6 6-6",
  },
  {
    title: "tour.courseSessions.s6.title",
    description: "tour.courseSessions.s6.desc",
    icon: "ft-unlock",
    accentGradient:
      "linear-gradient(135deg, hsl(25, 84%, 50%) 0%, hsl(32, 88%, 60%) 100%)",
    orbGradient:
      "radial-gradient(circle at 30% 30%, hsl(32, 88%, 65%), hsl(25, 84%, 50%))",
    svgPath:
      "M19 11H5a2 2 0 00-2 2v7a2 2 0 002 2h14a2 2 0 002-2v-7a2 2 0 00-2-2zM7 11V7a5 5 0 019.9-1",
  },
  {
    title: "tour.courseSessions.s7.title",
    description: "tour.courseSessions.s7.desc",
    icon: "ft-layers",
    accentGradient:
      "linear-gradient(135deg, hsl(221, 83%, 53%) 0%, hsl(200, 75%, 50%) 100%)",
    orbGradient:
      "radial-gradient(circle at 30% 30%, hsl(200, 75%, 60%), hsl(221, 83%, 53%))",
    svgPath: "M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5",
  },
  {
    title: "tour.courseSessions.s8.title",
    description: "tour.courseSessions.s8.desc",
    icon: "ft-check-circle",
    accentGradient:
      "linear-gradient(135deg, hsl(152, 68%, 38%) 0%, hsl(170, 55%, 45%) 100%)",
    orbGradient:
      "radial-gradient(circle at 30% 30%, hsl(152, 56%, 54%), hsl(170, 55%, 45%))",
    svgPath: "M22 11.08V12a10 10 0 11-5.93-9.14 M22 4L12 14.01l-3-3",
  },
  {
    title: "tour.courseSessions.s9.title",
    description: "tour.courseSessions.s9.desc",
    icon: "ft-video",
    accentGradient:
      "linear-gradient(135deg, hsl(250, 55%, 50%) 0%, hsl(250, 68%, 63%) 100%)",
    orbGradient:
      "radial-gradient(circle at 30% 30%, hsl(250, 68%, 68%), hsl(250, 55%, 50%))",
    svgPath:
      "M23 7l-7 5 7 5V7zM14 5H3a2 2 0 00-2 2v10a2 2 0 002 2h11a2 2 0 002-2V7a2 2 0 00-2-2z",
  },
  {
    title: "tour.courseSessions.s10.title",
    description: "tour.courseSessions.s10.desc",
    icon: "ft-zap",
    accentGradient:
      "linear-gradient(135deg, hsl(152, 68%, 38%) 0%, hsl(221, 83%, 53%) 50%, hsl(250, 55%, 50%) 100%)",
    orbGradient:
      "radial-gradient(circle at 30% 30%, hsl(152, 56%, 54%), hsl(221, 83%, 53%))",
    svgPath: "M13 2L3 14h9l-1 8 10-12h-9l1-8z",
  },
];
